import React, { useState, useEffect } from 'react'

// ** Icon Imports
import { useTranslation } from 'src/utils/i18n'
import Image from 'next/image'
import Dashboard1 from 'src/components/googleCloudStep/Dashboard1'

import Finish from 'src/components/googleCloudStep/Finish'
import Start from 'src/components/googleCloudStep/Start'
import GoogleDrive from 'src/components/googleCloudStep/GoogleDrive'
import PhotosVideos from 'src/components/googleCloudStep/PhotosVideos'
import Locations from 'src/components/googleCloudStep/Locations'
import Chrome from 'src/components/googleCloudStep/Chrome'
import Contacts from 'src/components/googleCloudStep/Contacts'
import TroubleShooting from 'src/components/googleCloudStep/TroubleShooting'
import WhatsApp from 'src/components/googleCloudStep/WhatsApp'
import BackupTips from 'src/components/googleCloudStep/BackupTips'
import CloudHavePhone from 'src/components/googleCloudStep/CloudHavePhone'
import CloudNoPhone from 'src/components/googleCloudStep/CloudNoPhone'
import { CheckCode } from 'src/@api/android'
import { message } from 'antd'
import { getNotBindOrder } from 'src/@api/login.js'
import { guardAppSetupOrderId } from 'src/utils/resolveCurrentOrderId'
import { redirectIfShouldBuyPackage } from 'src/utils/chooseDeviceRedirect'

function Index() {
  const { t } = useTranslation('commonAndroid')
  const [currentItem, setCurrentItem] = useState('BackupTips')
  const [appKey, setAppKey] = useState(1)
  const [setupBlocked, setSetupBlocked] = useState(true)

  //移动端全屏
  const [fullScreen, setFullScreen] = useState(false)

  const StepProgress = ({ current, total = 5 }) => {
    const barWidth = 72

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] Mlg:w-[51.8px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  useEffect(() => {
    const guard = guardAppSetupOrderId(window.location.search)
    if (guard.blocked) {
      setSetupBlocked(true)

      return
    }
    setSetupBlocked(false)

    if (guard.orderId) return

    const init = async () => {
      const result = await getNotBindOrder()
      await redirectIfShouldBuyPackage(result)
    }
    init()
  }, [])

  if (setupBlocked) return null

  return (
    <div>
      <div className={`Blds:shadow-step rounded-[10px] overflow-hidden bg-white relative h-[88vh] Local-step ${(currentItem === 'CloudHavePhone' || currentItem === 'CloudNoPhone') && '!h-[calc(100vh-62px)]'}`}>
        <div className={`bg-white h-full flex flex-col`} id='android-dashboard-login'>
          <div className={`Dmd:pb-[0px] Dsm:w-[calc(100%-40px)] mx-auto overflow-auto w-full mt-[60px] smj:mt-4 ${(currentItem === 'CloudHavePhone' || currentItem === 'CloudNoPhone') ? 'Dsm:pb-0' : 'Dsm:pb-[45px]'}`}>
            {currentItem === 'CloudHavePhone' && <CloudHavePhone setCurrentItem={setCurrentItem} />}
            {currentItem === 'CloudNoPhone' && <CloudNoPhone setCurrentItem={setCurrentItem} />}
            {currentItem === 'Finish' ? <StepProgress current={4} /> : (currentItem !== 'Start' && currentItem !== 'Finish' && currentItem !== 'App' && currentItem !== 'BackupTips' && currentItem !== 'Dashboard' && currentItem !== 'CloudHavePhone' && currentItem !== 'CloudNoPhone') && <StepProgress current={5} />}
            {currentItem === 'BackupTips' && <div><BackupTips setCurrentItem={setCurrentItem} fullScreen={fullScreen} setFullScreen={setFullScreen} /></div>}
            {/* {currentItem !== 'Start' &&
              currentItem !== 'Dashboard' &&
              currentItem !== 'App' &&
              currentItem !== 'Plugin' && currentItem !== 'BackupTips' ? (
              <div className='max-w-[800px] mx-auto py-[20px] flex justify-end'>
                <Image
                  src='/images/android/setup/close.svg'
                  width={20}
                  height={0}
                  alt='close'
                  className='Dsm:w-[15px] cursor-pointer'
                  onClick={() => window.location.assign('/')}
                />
              </div>
            ) : (
              <div className='max-w-[800px] mx-auto py-0 flex justify-end'></div>
            )} */}

            {currentItem !== 'Start' && currentItem !== 'Finish' && currentItem !== 'App' && currentItem !== 'BackupTips' && currentItem !== 'Dashboard' && currentItem !== 'CloudHavePhone' && currentItem !== 'CloudNoPhone' && (
              <div className='w-full h-[60px] Dsm:h-[58px] flex items-start'>
                {(currentItem === 'Google drive' ||
                  currentItem === 'Locations' ||
                  currentItem === 'WhatsApp' ||
                  currentItem === 'Photos & videos' ||
                  currentItem === 'Chrome' ||
                  currentItem === 'Contacts' ||
                  currentItem === 'Trouble shooting') && (
                    <div className='overflow-auto h-[42px] Dsm:h-[32px] bg-[#EEEEEF] rounded-[8px] p-[2px] flex justify-between mx-auto text-nowrap'>
                      <div
                        className={`${currentItem === 'Google drive'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Google drive')}
                      >
                        {t('Google drive')}
                      </div>
                      <div
                        className={`${currentItem === 'Locations'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Locations')}
                      >
                        {t('Locations')}
                      </div>
                      <div
                        className={`${currentItem === 'WhatsApp'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('WhatsApp')}
                      >
                        {t('WhatsApp')}
                      </div>
                      <div
                        className={`${currentItem === 'Photos & videos'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Photos & videos')}
                      >
                        {t('Photos  videos')}
                      </div>
                      <div
                        className={`${currentItem === 'Chrome'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Chrome')}
                      >
                        {t('Chrome')}
                      </div>
                      <div
                        className={`${currentItem === 'Contacts'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Contacts')}
                      >
                        {t('Contacts')}
                      </div>
                      <div
                        className={`${currentItem === 'Trouble shooting'
                          ? 'text-[#2405F2] bg-[#FFFFFF] shadow-[0_1px_3px_rgba(0,0,0,0.2)]'
                          : 'text-[#000]'
                          } px-[10px] Dsm:px-[8px] h-full text-[14px] flex items-center justify-center rounded-[6px] cursor-pointer`}
                        onClick={() => setCurrentItem('Trouble shooting')}
                      >
                        {t('Trouble shooting')}
                      </div>
                    </div>
                  )}
                <div className='w-full mx-auto fixed bottom-0 left-[150px] Mlg:left-0 right-0 bg-white border-t-[1px] border-[#E5E7EB]'>
                  <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
                    <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
                      <button className={`border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]`}
                        onClick={() => {
                          setCurrentItem('Finish')
                        }}>
                        <Image className='mr-[7px]' src='/images/bind/bind-arrow-blue.svg' width={18} height={18} alt='back' />
                        <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
                      </button>

                      <button className={`bg-[#FFCF55] rounded-[24px] h-[35px] flex items-center pl-[24px] pr-[10px]`}
                        onClick={() => { window.location.assign('/') }}>
                        <span className='text-[15px] text-[#1B1C2B] font-[600]'>{t('NEXT')}</span>
                        <Image className='ml-[6px]' src='/images/bind/bind-arrow-black.svg' width={18} height={18} alt='back' />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {currentItem === 'Start' && <Start setCurrentItem={setCurrentItem} />}
            {(currentItem === 'Dashboard' || currentItem === 'App' || currentItem === 'Plugin') && (
              <Dashboard1 currentItem={currentItem} setCurrentItem={setCurrentItem} appKey={appKey} fullScreen={fullScreen} setFullScreen={setFullScreen} />
            )}
            {currentItem === 'Finish' && <Finish setCurrentItem={setCurrentItem} />}
            {currentItem === 'Google drive' && <GoogleDrive />}
            {currentItem === 'Locations' && <Locations />}
            {currentItem === 'WhatsApp' && <WhatsApp />}
            {currentItem === 'Photos & videos' && <PhotosVideos />}
            {currentItem === 'Chrome' && <Chrome />}
            {currentItem === 'Contacts' && <Contacts />}
            {currentItem === 'Trouble shooting' && <TroubleShooting />}
          </div>
          {(currentItem === 'App' || currentItem === 'Plugin') && <div className='w-full h-[120px] Dsm:hidden'></div>}
        </div>
      </div>
    </div>
  )
}

export default Index